import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';
import queryString from 'query-string';

export default function setPackagingOption({
    baseUrl,
    brandId,
    country,
    uberToken,
    packagingOption,
    isGift,
    giftMessage,
    clientId,
    clientSecret,
    clearMessages = true,
    langId,
    additionalHeaders = {},
}) {
    invariant(baseUrl, 'baseUrl is a required param of setPackagingOption()');
    invariant(brandId, 'brandId is a required param of setPackagingOption()');
    invariant(country, 'country is a required param of setPackagingOption()');
    invariant(uberToken, 'uberToken is a required param of setPackagingOption()');
    invariant(packagingOption, 'packagingOption is a required param of setPackagingOption()');
    invariant(clientId, 'clientId is a required param of setPackagingOption()');

    const headers = { 'Content-Type': 'application/json', ...additionalHeaders };
    const query = queryString.stringify({ clearMessages, langId });
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country}/cart/@self/shipping_info?${query}`;

    const body = {
        addressId: '0', // zero must be passed if addressId is unknown, or already set and you don't want to change it. See API.
        x_packagingOption: packagingOption,
        x_isGift: isGift,
        x_giftMessage: giftMessage,
    };

    return labelRequest(
        authenticatedRequest(new Request(url, { headers: new Headers(headers), method: 'PUT', body: JSON.stringify(body) }), uberToken, clientId, clientSecret),
        'setPackagingOption',
    );
}
